import { render, staticRenderFns } from "./AulaPopover.vue?vue&type=template&id=a943d4d0&scoped=true&"
import script from "./AulaPopover.vue?vue&type=script&lang=js&"
export * from "./AulaPopover.vue?vue&type=script&lang=js&"
import style0 from "./AulaPopover.vue?vue&type=style&index=0&id=a943d4d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a943d4d0",
  null
  
)

export default component.exports